export default __webpack_public_path__ + "static/media/11.cde8098b.jpg";